import { useState, useEffect } from "react";
import { logEvent } from "../../analytics";
import { EVENTS } from "../../constants/ga-constants";
import DealRequestCard from "../../components/deal-request-card";
import axiosInstance from "../../axios";

const MyRequests = () => {
  const [deals, setDeals] = useState([]);
  const [paymentPopUp, setPaymentPopUp] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getUserDashboardDetails();
  }, []);

  const getUserDashboardDetails = () => {
    try {
      setLoading(true);
      axiosInstance
        .get(`/v1/student/dashboard`)
        .then(data => {
          const response = data.data;
          const userData = {
            profilePic: response.profile_pic,
            Name: response.user_name,
            userId: response.id,
          };

          localStorage.setItem("userDetails", JSON.stringify(userData));

          setDeals(response.requests_data);
          if (
            JSON.parse(localStorage.getItem("paymentPopUp")) &&
            !response.requests_data?.find(deal => deal.advance_payment > 0)
          )
            setPaymentPopUp(response.requests_data[0]?.advance_amount);
          setLoading(false);
        })
        .catch(err => {});
    } catch (error) {}
  };
  return (
    <div
      className="personal-info--content--page"
      onClick={() => {
        logEvent(EVENTS.CARD_CLICKED.event_name);
      }}>
      {loading && (
        <div className="subscription-loading">
          <div className="loading">
            <img src="/book-loader.gif" alt="Loading..." />
          </div>
        </div>
      )}
      {deals
        ?.slice()
        .reverse()
        .map((i, indx) => (
          <DealRequestCard key={indx} data={i} />
        ))}
    </div>
  );
};

export default MyRequests;
